import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import JobFilterContext from "./contexts/JobFilterContext";
import AddOrUpdateJob from "./pages/AddOrUpdateJob";
import AvailableJobs from "./pages/AvailableJobs";
import './styles/style.css';

function App() {
	const [jobFilter, setJobFilter] = useState('');

	return (
		<>
			<Navbar />
			<div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
				<BrowserRouter>
					<JobFilterContext.Provider value={{jobFilter, setJobFilter}} >
						<Sidebar />
						<div className="lg:pl-[14rem]  mt-[5.8125rem]">
							<main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
								<Routes>
									<Route path="/" element={<AvailableJobs  />} />
									<Route path="/newjob" element={<AddOrUpdateJob />} />
									<Route path="/editjob/:jobId" element={<AddOrUpdateJob />} />
								</Routes>
							</main>
						</div>
					</JobFilterContext.Provider>
				</BrowserRouter>
			</div>
		</>
	);
}

export default App;
